import React from "react";

import { DataContext } from "../../contexts/dataContext";
import Scenario from "./scenario";

export default props => (
  <DataContext.Consumer>
    {({ scenarios }) => (
      <Scenario
        scenarios={scenarios}
        {...props}
      />
    )}
  </DataContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/components/Scenario/index.js